import { TbCode, TbRobot } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const developerRoutes: NavigationRoute[] = [
    {
        meta: {
            label: "developer",
            order: 7,
            icon: TbCode,
            visibleInSidebar: false,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
        to: APP_ROUTES_TO.DEVELOPER,
    },
    /** Telli is the only developer page exposed in the sidebar, for setting team leads. */
    {
        meta: {
            label: "developer_telli_title",
            order: 8,
            icon: TbRobot,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_TELLI_MANAGE],
        },
        to: APP_ROUTES_TO.DEVELOPER_TELLI,
    },
];
